import React, { useEffect, useState } from 'react';
import { Row, Col, Dropdown, Button, ButtonGroup, Form, Modal } from 'react-bootstrap';
import { IoTodaySharp } from "react-icons/io5";
import axios from 'axios';
import './today-report.css';
import WorkReportLayout from '../../components/EmpWorkReportLayout.jsx';
import { IoMdEye } from "react-icons/io";

export default function TodayReport() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);  // State for modal visibility
  const [selectedReport, setSelectedReport] = useState(null); // State for selected report

  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [employeeData, setEmployeeData] = useState([]); // Employee data for pagination

  const fetchTodayReports = async (name = '') => {
    try {
      setLoading(true);
      setError(null);

      // API request to search reports created today
      const response = await axios.get('https://backend.ems.hiradentallab.com/api/reports/reports/today/search', {
        params: { name },
      });

      console.log('API Response:', response.data);

      if (response.data) {
        setReports(response.data);  // Set the reports data correctly
        setEmployeeData(response.data); // Set data for pagination
      } else {
        setError("No reports available for today");
        setReports([]);
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
      setError("Error fetching reports: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodayReports();  // Fetch all reports when the component mounts
  }, []);

  const handleShowModal = (report) => {
    setSelectedReport(report);  // Set the selected report
    setShowModal(true); // Open the modal
  };

  const handleCloseModal = () => {
    setShowModal(false);  // Close the modal
    setSelectedReport(null); // Reset selected report
  };

  const handleSearch = (e) => {
    e.preventDefault(); // Prevent form's default reload behavior
    fetchTodayReports(searchQuery); // Fetch filtered reports based on search query
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString(); // Format date
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageRange = () => {
    const totalPages = Math.ceil(employeeData.length / entriesPerPage);
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const totalPages = Math.ceil(employeeData.length / entriesPerPage);

  const indexOfLastReport = currentPage * entriesPerPage;
  const indexOfFirstReport = indexOfLastReport - entriesPerPage;
  const currentReports = reports.slice(indexOfFirstReport, indexOfLastReport);

  return (
    <div className="container-fluid">
    <WorkReportLayout>
      <div>
        <h1 className="today-report-header">
          <IoTodaySharp className="today-report-icon" />
          Today Work Reports
        </h1>
        <hr />
        <div className="today-report-content">
          <div>
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                <Dropdown as={ButtonGroup}>
                  <Button variant="primary">Show Entries</Button>
                  <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                  <Dropdown.Menu>
                    {[10, 25, 50, 100].map(size => (
                      <Dropdown.Item key={size} onClick={() => setEntriesPerPage(size)}>
                        {size}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end mb-3 search-container">
                <Form className="d-flex" onSubmit={handleSearch}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Form>
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className='table-header '>
                  <tr className='today-report-table-header'>
                    <th>SR</th>
                    <th>Name</th>
                    <th>UserName</th>
                    <th>Reporting Date</th>
                    <th>Reporting Time</th>
                    <th>Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center' }}>Loading...</td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center' }}>{error}</td>
                    </tr>
                  ) : currentReports.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center' }}>No reports available for today</td>
                    </tr>
                  ) : (
                    currentReports.map((report, index) => (
                      <tr key={report._id}>
                        <td>{index + 1}</td>
                        <td>{report.name}</td>
                        <td>{report.username}</td>
                        <td>{new Date(report.reportingDate).toLocaleDateString()}</td>
                        <td>{(report.reportingTime)}</td>
                        <td>{new Date(report.updatedAt).toLocaleString()}</td>
                        <td><Button variant="primary" size='sm' onClick={() => handleShowModal(report)}><IoMdEye /></Button></td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot className='table-footer'>
                  <tr className='today-report-table-footer'>
                    <td>Total</td>
                    <td className="text-right">{reports.length}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>

              {/* Pagination */}
              <div className="pagination-row">
                <div className="entries-info">
                  Showing {(currentPage - 1) * entriesPerPage + 1} to{" "}
                  {Math.min(currentPage * entriesPerPage, employeeData.length)} of{" "}
                  {employeeData.length} entries
                </div>
                <nav>
                  <ul className="pagination no-gap">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map((pageNumber) => (
                      <li
                        key={pageNumber}
                        className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
                      >
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNumber);
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    ))}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for report details */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{ background: "#004aad", color: "#ffffff" }}>
          <Modal.Title>Report Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
          {selectedReport && (
            <div>
              <h6 style={{ fontWeight: "bold" }}>
                Start Date:{" "}
                <span style={{ fontStyle: "italic", color: "#007bff" }}>
                  {formatDate(selectedReport.reportingDate)}
                </span>
              </h6>
              <h6 style={{ fontWeight: "bold" }}>
                Reporting Time:{" "}
                <span style={{ fontStyle: "italic", color: "#007bff" }}>
                  {(selectedReport.reportingTime)}
                </span>
              </h6>
              <div
                style={{
                  border: "1px solid #007bff",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                dangerouslySetInnerHTML={{ __html: selectedReport.report }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </WorkReportLayout>
    </div>
  );
}
